import React, { useState } from "react";
import {
    Paper,
    Typography,
    Box,
    IconButton,
    Collapse,
} from "@mui/material";

import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";

import AttentionCard from "./AttentionCard";

export default function AttentionBanner({
    items = [],
    onDismiss,
    onAction,
}) {
    const [expanded, setExpanded] = useState(false);

    if (!items.length) return null;

    const collapsedItems = items.slice(0, 3);
    const remainingItems = items.slice(3);

    return (
        <Paper
            elevation={0}
            sx={{
                width: "100%",
                border: "1px solid #F4D58D",
                borderRadius: "8px",
                backgroundColor: "#FFF8E7",
                p: 1,
                mb: 1,
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <WarningAmberRoundedIcon
                        sx={{
                            color: "#BB4D00",
                            fontSize: 22,
                        }}
                    />

                    <Typography
                        sx={{
                            fontSize: 20,
                            fontWeight: 450,
                            color: "#BB4D00",
                        }}
                    >
                        Needs Attention
                    </Typography>
                </Box>

                {items.length > 3 && (
                    <IconButton
                        onClick={() => setExpanded((prev) => !prev)}
                        sx={{
                            color: "#BB4D00",
                        }}
                    >
                        {expanded ? (
                            <KeyboardArrowUpRoundedIcon />
                        ) : (
                            <KeyboardArrowDownRoundedIcon />
                        )}
                    </IconButton>
                )}
            </Box>

            <Box
                sx={{
                    height: "1px",
                    width: "100%",
                    bgcolor: "#F4D58D",
                    mb: 1.5,
                }}
            />

            {/* First Row — flex:1 wrappers + nowrap so 3 cards always share one line on md+ */}
            <Box
                sx={{
                    display: "flex",
                    flexWrap: { xs: "wrap", md: "nowrap" },
                    gap: 1.25,
                }}
            >
                {collapsedItems.map((item) => (
                    <Box
                        key={item.id}
                        sx={{
                            flex: "1 1 0",
                            minWidth: { xs: "100%", md: 220 },
                        }}
                    >
                        <AttentionCard
                            {...item}
                            onDismiss={() => onDismiss?.(item.id)}
                            onAction={() => onAction?.(item)}
                        />
                    </Box>
                ))}
            </Box>

            {/* Remaining Cards */}
            {items.length > 3 && (
                <Collapse in={expanded}>
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1.25,
                            mt: 1.25,
                        }}
                    >
                        {remainingItems.map((item) => (
                            <Box
                                key={item.id}
                                sx={{
                                    flex: "1 1 0",
                                    minWidth: { xs: "100%", md: 220 },
                                }}
                            >
                                <AttentionCard
                                    {...item}
                                    onDismiss={() => onDismiss?.(item.id)}
                                    onAction={() => onAction?.(item)}
                                />
                            </Box>
                        ))}
                    </Box>
                </Collapse>
            )}
        </Paper>
    );
}